import { useCopiedState } from "../../../../core/util/hooks";
import { OrderFilter } from "../../../models";
import { setFilter, removeFilter, initialState } from "../ordersReportUXSlice";
import { invalidateOrders } from "../ordersReportDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";

export const useOrdersReportFilter = () => {
	const [storeFilter] = useCurrentOrdersReportFilter();
	const [filter, editFilter, changeState, setCurrentFilter] = useCopiedState<OrderFilter>(storeFilter);

	const dispatch = useDispatch();
	const dispatchSetFilter = React.useCallback(() => {
		dispatch(setFilter(filter!));
		dispatch(invalidateOrders());
	}, [dispatch, filter]);

	const dispatchResetFilter = React.useCallback(() => {
		setCurrentFilter(initialState.filter)
	}, [setCurrentFilter]);

	return [filter, editFilter, dispatchSetFilter, changeState, dispatchResetFilter] as [
		typeof filter,
		typeof editFilter,
		typeof dispatchSetFilter,
		typeof changeState,
		typeof dispatchResetFilter,
	];
};

export const useCurrentOrdersReportFilter = () => {
	const filter = useSelector<StoreType, OrderFilter>(store => store.ux.reports.ordersReport.filter);
	const dispatch = useDispatch();
	const dispatchRemoveFilter = React.useCallback(
		(type: keyof OrderFilter) => {
			dispatch(removeFilter(type));
			dispatch(invalidateOrders());
		},
		[dispatch]
	);

	return [filter, dispatchRemoveFilter] as [typeof filter, typeof dispatchRemoveFilter];
};
